import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function Phone({ member }) {
  return (

    <ValueItem
      icon="phone-icon"
      label="Phone Number"
    >
      {member.phone}
    </ValueItem>
  );
}

Phone.propTypes = {
  member: PropTypes.object.isRequired,
};
